require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-150-portfolio-view.json") })
        }
      }, "path---article-150-portfolio-view");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-150-portfolio-view!./.cache/json/article-150-portfolio-view.json
// module id = 499
// module chunks = 231608221292675